import React from 'react'
import "./payment_online.scss"

const Payment_Online = () => {
  return (
    <div className='onehihi'>Payment_Online</div>
  )
}

export default Payment_Online